module.exports = __webpack_public_path__ + "static/SureCloud-555397e609e79bb0cd5d5e908153b35c.jpg";